import styled from 'styled-components';
import { Table } from 'edenred-ui';

import { MassUploadStatus } from '@epi-models/pages/MassUpload';

const getStatusBadgeColor = (status: MassUploadStatus, theme: any) => {
  switch (status) {
    case MassUploadStatus.Closed:
      return theme.positiveColor;
    case MassUploadStatus.ClosedWithFailures:
      return theme.warningColor;
    default:
      return theme.gray25;
  }
};

export const TableContainer = styled.div`
  background-color: ${({ theme }) => theme.primaryBackgroundColor};
  overflow-x: auto;
`;

export const StyledTable = styled(Table)`
  table-layout: fixed;
  width: 100%;
  min-width: 1000px;
  border-collapse: collapse;
`;

export const TableHeaderCell = styled(Table.Cell)<{
  alignRight?: boolean;
}>`
  font-weight: ${({ theme }) => theme.fontBold};
  color: ${({ theme }) => theme.primaryFontColor};
  border-bottom: 2px solid ${({ theme }) => theme.gray10};
  padding: 12px 16px;
  text-align: ${({ alignRight }) => (alignRight ? 'right' : 'left')};
`;

export const StyledRow = styled(Table.Row)<{
  hasFailed?: boolean;
  clickable?: boolean;
}>`
  background-color: ${({ hasFailed, theme }) =>
    hasFailed ? theme.warningBackgroundColor : 'transparent'} !important;
  transition: background-color 0.2s ease-in-out;
  cursor: ${({ clickable }) => (clickable ? 'pointer' : 'default')};

  &:hover {
    background-color: ${({ hasFailed, theme }) =>
      hasFailed ? theme.warningBackgroundColor : theme.gray5} !important;
  }
`;

export const TableCell = styled(Table.Cell)<{
  width?: string;
  alignRight?: boolean;
}>`
  width: ${({ width }) => width || 'auto'};
  padding: 12px 16px;
  text-align: ${({ alignRight }) => (alignRight ? 'right' : 'left')};
  vertical-align: middle;
  font-size: ${({ theme }) => theme.sizeSmall};
  color: ${({ theme }) => theme.primaryFontColor};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const DateCell = styled(TableCell)`
  white-space: pre-line;
  line-height: 1.6;
`;

export const FailedCount = styled.span<{ hasFailed: boolean }>`
  color: ${({ hasFailed, theme }) =>
    hasFailed ? theme.warningColor : 'inherit'};
  font-weight: ${({ hasFailed, theme }) =>
    hasFailed ? theme.fontSemiBold : 'inherit'};
`;

export const ChevronCell = styled(TableCell)`
  text-align: center;
  color: ${({ theme }) => theme.gray50};
`;

export const StatusBadge = styled.div<{ status: MassUploadStatus }>`
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;

  &::before {
    content: '';
    flex: 0 0 12px;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ status, theme }) =>
      getStatusBadgeColor(status, theme)};
  }
`;
